export enum BankFeedRouteName {
    Index = 'finance.bankFeeds.index',
    Import = 'finance.bankFeeds.import',
    History = 'finance.bankFeeds.history',
}

export default {
    path: 'bank-feeds',
    name: 'finance.bankFeeds.index',
    component: () => import('@/views/finance/bank_feed/Index.vue'),
    meta: {
        label: 'Bank Feeds',
        auth: true,
        permission: 'manage-bank-feeds',
        icon: 'fal fa-file-invoice-dollar fa-fw',
        location: 'sidebar',
        parent: 'finance',
    },
    children: [
        {
            path: 'import',
            name: BankFeedRouteName.Import,
            component: () => import('@/views/finance/bank_feed/Index.vue'),
            meta: {
                label: 'Bank Feeds',
                auth: true,
                permission: 'manage-bank-feeds',
                icon: 'fal fa-file-invoice-dollar fa-fw',
                location: 'sidebar',
                parent: 'finance.bankFeeds.index',
            },
        },
        {
            path: ':bankFeedUuid/history',
            name: BankFeedRouteName.History,
            component: () => import('@/views/finance/bank_feed/Index.vue'),
            meta: {
                label: 'History',
                auth: true,
                permission: 'manage-bank-feeds',
                icon: 'fal fa-file-invoice-dollar fa-fw',
                location: 'sidebar',
                parent: 'finance.bankFeeds.index',
            },
        },
    ],
}
